export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-agnr-api.tracwater.online', // Develop Server
  portalId: '6a6aca5d7efe74d1d36eb17b',
  portalTypeId: '689596ee18f8a8985a2aebc5',
};
